import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect:'/Index',
      component:()=>import('@/page/Index')
    },
    {
      path:'/index',
      name:'Index',
      redirect:'/Home',
      component:()=>import('@/page/Index'),
      children:[
        {
          path:'/home',
          name:'Home',
          component:()=>import('@/page/Home')
        },{
          path:'/aboutus',
          name:'aboutUs',
          component:()=>import('@/page/aboutUs')
        },{
          path:'/news',
          name:'News',
          component:()=>import('@/page/News')
        },{
          path:'/case',
          name:'Case',
          component:()=>import('@/page/Case')
        },{
          path:'/product',
          name:'Product',
          component:()=>import('@/page/Product')
        },{
          path:'/vip',
          name:'Vip',
          component:()=>import('@/page/Vip')
        },{
          path:'/channel',
          name:'Channel',
          component:()=>import('@/page/Channel')
        },{
          path:'/joinIn',
          name:'joinIn',
          component:()=>import('@/page/joinIn')
        },{
          path:'/extension',
          name:'Extension',
          component:()=>import('@/page/Extension')
        },{
          path:'/online',
          name:'onLine',
          component:()=>import('@/page/onLine')
        },{
          path:'/recruit',
          name:'Recruit',
          component:()=>import('@/page/Recruit')
        }]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js